module.exports = __webpack_public_path__ + "static/img/14000315.73cd06ec.png";